module.exports = __webpack_public_path__ + "img/globe-solid.86098b36.svg";